export default "../media/right_arrow.471b6426909878d496dc41aa4667f93b.svg";